module.exports = __webpack_public_path__ + "assets/21678e1c1be13c60be60abb922e6b9ed.mp3";